import { Component } from '@angular/core'

@Component({
  selector: 'se-po-missing-persona-info-docs',
  templateUrl: './se-missing-persona-info-docs.component.html',
  styleUrls: ['./se-missing-persona-info-docs.component.scss'],
  standalone: false,
})
export class SeMissingPersonaInfoDocsComponent {
}
